export default __webpack_public_path__ + "static/book-covers@2x-abb20a1140df60e5d09b942c93f00813.jpg";